import React, { Component } from 'react';
import { Tooltip } from 'bootstrap';

export class IO8Expander extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {

        const addressFlags = [[1, 0, 0, 0], [0, 1, 0, 0], [1, 1, 0, 0], [0, 0, 1, 0], [1, 0, 1, 0], [0, 1, 1, 0], [1, 1, 1, 0], [0, 0, 0, 1], [1, 0, 0, 1], [0, 1, 0, 1], [1, 1, 0, 1], [0, 0, 1, 1], [1, 0, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1]];

        const addr = addressFlags[this.props.address - 1];
        var parent = document.querySelector('#io8-' + this.props.address);

        
        for (var n = 0; n < 4; n++) 
            new Tooltip(parent.querySelector('#relayChip' + (n + 1)), { title: 'Field replaceable solid state relay. Default relay is 30V@500mA N/O however other options with higher amperage or normally closed can be installed.'})

        new Tooltip(parent.querySelector('#lightSensor'), { title: 'Light sensor used to detect when the enclosure is opened to trigger tamper sensor alarm. Enabled when the <strong>F2</strong> DIP switch is set.', placement: 'top', html: true })
        new Tooltip(parent.querySelector('#d3LED'), {title: 'Indicates when a input changes state or when the light sensor detects a change.'})

        // Headers

        for (var n = 0; n < 8; n++)
            new Tooltip(parent.querySelector('#relay' + (n + 1)), { title: "30V AC or DC @ 500mA <br /> Normally Open <br /> 22AWG Shielded up to 152m or 500ft.", html: true });

        new Tooltip(parent.querySelector('#powerOutput'), { title: "12VDC Output <br />Enabled when <strong>F0</strong> DIP switch is set.<br />Maximum current set by <strong>F1</strong> DIP switch: 120mA Off / 280mA On", html: true });

        new Tooltip(parent.querySelector('#input12'), { title: "Dry contact inputs 1 & 2 with a shared ground. <br /> 22AWG Shielded up to 152m or 500ft.", html: true });
        new Tooltip(parent.querySelector('#input34'), { title: "Dry contact inputs 3 & 4 with a shared ground. <br /> 22AWG Shielded up to 152m or 500ft.", html: true });
        new Tooltip(parent.querySelector('#input56'), { title: "Dry contact inputs 5 & 6 with a shared ground. <br /> 22AWG Shielded up to 152m or 500ft.", html: true });
        new Tooltip(parent.querySelector('#input78'), { title: "Dry contact inputs 7 & 8 with a shared ground. <br /> 22AWG Shielded up to 152m or 500ft.", html: true });

        new Tooltip(parent.querySelector('#rs485Header'), { title: 'RS-485 connection to main controller. <br /> Connected using a PRS-STRIP inside of an enclosure or using 22AWG shielded wire up to 1200m or 4000ft.', html: true, placement: 'left' })

        // Dip Switches

        var msg = "&nbsp;";
        for (n = 0; n < 15; n++) {
            msg += "<span class='text-danger'>" + (n + 1) + "</span> "
            if ((n + 1) < 10)
                msg += "&nbsp;";
            msg += addressFlags[n].join("") + "&nbsp;"
            if ((n + 1) % 3 === 0)
                msg += "<br />" + ((n + 1) !== 15 ? "&emsp;" : "")

        }

        new Tooltip(parent.querySelector('#dipswitch'), {
            title: '8 DIP switches to configure board address and functions<br />' +
                '<div class="text-start font-monospace"><strong>A0-A3:</strong> Board Address (1-15)<br />' + msg + '<strong>F0:</strong> Enable 12VDC Output<br /><strong>F1:</strong> Set 12VDC Current<br />&emsp;&emsp;&emsp;&emsp;120mA Off / 280mA On<br /><strong>F2:</strong> Enable Light Sensor<br /><strong>F3:</strong> Enable Test Mode</div>', html: true
        })

        parent.querySelector('#sw1').setAttribute("class", "switch " + (addr[0] === 1 ? "on" : "off"));
        parent.querySelector('#sw2').setAttribute("class", "switch " + (addr[1] === 1 ? "on" : "off"));
        parent.querySelector('#sw3').setAttribute("class", "switch " + (addr[2] === 1 ? "on" : "off"));
        parent.querySelector('#sw4').setAttribute("class", "switch " + (addr[3] === 1 ? "on" : "off"));
        parent.querySelector('#sw5').setAttribute("class", "switch off");
        parent.querySelector('#sw6').setAttribute("class", "switch off");
        parent.querySelector('#sw7').setAttribute("class", "switch off");
        parent.querySelector('#sw8').setAttribute("class", "switch off");

        const selectors = parent.querySelectorAll(".switch")
        for (var n of selectors)
            n.addEventListener('pointerup', (e) => {
                e.target.parentElement.setAttribute("class", e.target.parentElement.getAttribute("class") === "switch off" ? "switch on" : "switch off");
        });
    }

    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                id={"io8-" + this.props.address}
                className="io8"
                width="350.052"
                height="350"
                version="1.1"
                viewBox="0 0 350.052 350"
            >
                <style id="style9683">
                    .green-led-fast { } .yellow-led-fast { } .green-led-slow { } .chip { }{" "}
                    .switch { } .off { } .on { } .green-led { } .red-led { } .yellow-led { } .led{" "}
                    { } .header-background { } .header { }
                </style>
                <defs id="defs6">
                    <clipPath id="clipPath26" clipPathUnits="userSpaceOnUse">
                        <path id="path24" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath106" clipPathUnits="userSpaceOnUse">
                        <path id="path104" d="M0 612h792V0H0z"></path>
                    </clipPath>
                </defs>
                <g id="g10" transform="matrix(1.33333 0 0 -1.33333 .298 816)">
                    <g id="g400" transform="translate(-.184)">
                        <path
                            id="path14"
                            fill="#318e4e"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            strokeWidth="0.999"
                            d="M262.5 349.5H0v51.717h17.023v4.72H0v18.866h17.023v4.882H0V612h262.5z"
                            display="inline"
                        ></path>
                        <path
                            id="path18"
                            fill="none"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.499"
                            d="M262.25 349.75H.25v51.618h16.99v4.71H.25v18.831h16.99v4.873H.25V611.75h262z"
                            display="inline"
                        ></path>
                        <g id="g22" clipPath="url(#clipPath26)" display="inline">
                            <g id="g481" transform="translate(30.695 -4.332)">
                                <path
                                    id="path30"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M209.145 597.625a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                ></path>
                                <path
                                    id="path34"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M209.645 597.125a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                            <g id="g477" transform="translate(3.75 -4.332)">
                                <path
                                    id="path38"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M25.5 597.125a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path42"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M25.5 597.125a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                            <g id="g473" transform="translate(0 -17.24)">
                                <path
                                    id="path46"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M29.25 397.033a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path50"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M29.25 397.033a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                            <g id="g469" transform="translate(-38.216 -15.335)">
                                <path
                                    id="path54"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M278.556 395.127a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path58"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M278.556 395.127a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g id="g9244" transform="translate(1.09 .168)">
                            <path
                                id="lightSensor"
                                fill="#ccc"
                                fillOpacity="1"
                                strokeDasharray="none"
                                strokeWidth="0.75"
                                d="M109.772 -469.367H116.05900000000001V-459.93600000000004H109.772z"
                                transform="scale(1 -1)"
                            ></path>
                        </g>
                        <g
                            id="g4867"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            display="inline"
                            transform="translate(0 -23.36)"
                        >
                            <path
                                id="path60"
                                fill="#856a3c"
                                d="M-.04 432.385h14.747v13.224H-.04z"
                                display="inline"
                            ></path>
                            <path
                                id="path70"
                                fill="#efd89d"
                                d="M13.134 433.34H1.255a1.294 1.294 0 000 2.59h11.88a1.294 1.294 0 000-2.59"
                                display="inline"
                            ></path>
                            <path
                                id="path66"
                                fill="#efd89d"
                                d="M13.134 437.654H1.255a1.294 1.294 0 000 2.589h11.88a1.294 1.294 0 100-2.59"
                                display="inline"
                            ></path>
                            <path
                                id="path62"
                                fill="#efd89d"
                                d="M-.04 441.942H14.43v2.59H-.04z"
                                display="inline"
                            ></path>
                        </g>
                        <g id="g3924" display="inline" transform="translate(-.04)">
                            <g id="g3882" transform="translate(-54.822 50.737)">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "monospace",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text3872"
                                    x="168.121"
                                    y="-533.419"
                                    fill="red"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan
                                        id="tspan3870"
                                        style={{
                                            InkscapeFontSpecification: "monospace",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="168.121"
                                        y="-533.419"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        PWR
                                    </tspan>
                                </text>
                                <path
                                    id="pwrLED"
                                    fill="red"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                    className="led red-led"
                                    transform="matrix(1 0 0 -1 -148.079 216.91)"
                                ></path>
                            </g>
                            <g id="g3906" transform="translate(-63.287 -122.074)">
                                <text
                                    id="text3902"
                                    x="169.577"
                                    y="-533.139"
                                    fill="red"
                                    strokeWidth="0.75"
                                    fontSize="8"
                                    transform="scale(1 -1)"
                                    xmlSpace="preserve"
                                >
                                    <tspan
                                        id="tspan3900"
                                        x="169.577"
                                        y="-533.139"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontSize="8"
                                    >
                                        D3
                                    </tspan>
                                </text>
                                <path
                                    id="d3LED"
                                    fill="red"
                                    strokeWidth="0.75"
                                    d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                    className="led red-led"
                                    transform="matrix(1 0 0 -1 -148.079 216.91)"
                                ></path>
                            </g>
                            <g id="g3898" transform="translate(-1.352 21.513)">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "monospace",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text3894"
                                    x="173.076"
                                    y="-533.367"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan
                                        id="tspan3892"
                                        style={{
                                            InkscapeFontSpecification: "monospace",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="173.076"
                                        y="-533.367"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D2
                                    </tspan>
                                </text>
                                <path
                                    id="d2LED"
                                    fill="#ffcd00"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M174.802 -545.487H180.201V-541.5169999999999H174.802z"
                                    className="led yellow-led"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g id="g3890" transform="translate(-15.717 21.513)">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text3886"
                                    x="172.441"
                                    y="-533.367"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan
                                        id="tspan3884"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="172.441"
                                        y="-533.367"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D1
                                    </tspan>
                                </text>
                                <path
                                    id="d1LED"
                                    fill="#7fff2a"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M174.802 -545.487H180.201V-541.5169999999999H174.802z"
                                    className="led green-led green-led-slow"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g id="txLEDGroup" transform="translate(-132.927 -8.487)">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "monospace",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text10149"
                                    x="214.329"
                                    y="-553.938"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan id="tspan10155" x="214.329" y="-553.938">
                                        Tx
                                    </tspan>
                                </text>
                                <path
                                    id="txLED"
                                    fill="#ffcd00"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M225.894 -558.008H231.293V-554.038H225.894z"
                                    className="led yellow-led yellow-led-fast"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g id="g10163" transform="translate(-132.927 -18.9)">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "monospace",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text10159"
                                    x="214.329"
                                    y="-553.938"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan id="tspan10165" x="214.329" y="-553.938">
                                        Rx
                                    </tspan>
                                </text>
                                <path
                                    id="rxLED"
                                    fill="#7fff2a"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M225.894 -558.008H231.293V-554.038H225.894z"
                                    className="led yellow-led green-led green-led-fast"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                        </g>
                    </g>
                    <g id="g8430" display="inline" transform="translate(-137.028 94.952)">
                        <path
                            id="path8418"
                            fill="#000"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M354.998 329.112h-26.72v30.436h26.72z"
                        ></path>
                        <path
                            id="path8420"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 351.191h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path8422"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 345.133h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path8424"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 339.506h-22.918v3.093h22.918z"
                        ></path>
                        <path
                            id="path8426"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 333.879h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="relayChip4"
                            fill="#e8e3d4"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M350.437 331.511h-17.622v25.534h17.622z"
                            className="chip"
                        ></path>
                    </g>
                    <g id="g8416" display="inline" transform="translate(-137.028 136.202)">
                        <path
                            id="path8404"
                            fill="#000"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M354.998 329.112h-26.72v30.436h26.72z"
                        ></path>
                        <path
                            id="path8406"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 351.191h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path8408"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 345.133h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path8410"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 339.506h-22.918v3.093h22.918z"
                        ></path>
                        <path
                            id="path8412"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 333.879h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="relayChip3"
                            fill="#e8e3d4"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M350.437 331.511h-17.622v25.534h17.622z"
                            className="chip"
                        ></path>
                    </g>
                    <g id="g8402" display="inline" transform="translate(-137.028 177.452)">
                        <path
                            id="path8390"
                            fill="#000"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M354.998 329.112h-26.72v30.436h26.72z"
                        ></path>
                        <path
                            id="path8392"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 351.191h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path8394"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 345.133h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path8396"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 339.506h-22.918v3.093h22.918z"
                        ></path>
                        <path
                            id="path8398"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 333.879h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="relayChip2"
                            fill="#e8e3d4"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M350.437 331.511h-17.622v25.534h17.622z"
                            className="chip"
                        ></path>
                    </g>
                    <g id="g8336" display="inline" transform="translate(-137.028 218.702)">
                        <path
                            id="path7241"
                            fill="#000"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M354.998 329.112h-26.72v30.436h26.72z"
                        ></path>
                        <path
                            id="path7243"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 351.191h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path7245"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 345.133h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="path7247"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 339.506h-22.918v3.093h22.918z"
                        ></path>
                        <path
                            id="path7249"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M353.184 333.879h-22.918v3.094h22.918z"
                        ></path>
                        <path
                            id="relayChip1"
                            fill="#e8e3d4"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M350.437 331.511h-17.622v25.534h17.622z"
                            className="chip"
                        ></path>
                    </g>
                    <g id="dipswitch" display="inline" transform="translate(-33.887 72.95)">
                        <path
                            id="path72"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M165.656 378.5h-3.322v31.008h3.322z"
                        ></path>
                        <path
                            id="path74"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M172.217 378.5h-3.323v31.008h3.323z"
                        ></path>
                        <path
                            id="path76"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M178.812 378.455h-3.322v31.008h3.322z"
                        ></path>
                        <path
                            id="path78"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M184.984 378.455h-3.322v31.008h3.322z"
                        ></path>
                        <path
                            id="path80"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M191.342 378.455h-3.323v31.008h3.323z"
                        ></path>
                        <path
                            id="path8761"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M197.53 378.455h-3.322v31.008h3.323z"
                        ></path>
                        <path
                            id="path8764"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M203.906 378.455h-3.323v31.008h3.323z"
                        ></path>
                        <path
                            id="path8767"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M210.28 378.455h-3.322v31.008h3.323z"
                        ></path>
                        <path
                            id="path440"
                            fill="#32312c"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            strokeWidth="1.234"
                            d="M213.887 383.418h-54.691v21.08h54.691z"
                        ></path>
                        <text
                            id="text464"
                            x="142.672"
                            y="-438.988"
                            fill="#fff"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            strokeWidth="1.142"
                            fontFamily="monospace"
                            fontSize="4.57"
                            fontStretch="normal"
                            fontStyle="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="scale(1.14245 -.87531)"
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                        >
                            <tspan id="tspan710" x="142.672" y="-438.988" strokeWidth="1.142">
                                1 2 3 4 5 6 7 8
                            </tspan>
                        </text>
                        <g id="sw1" className="switch">
                            <path
                                id="sw1Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M166.027 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw1Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M165.656 389.117h-2.951v2.951h2.95z"
                                className="off"
                                display="inline"
                            ></path>
                            <path
                                id="sw1On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M165.656 397.612h-2.951v2.951h2.951z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw2" className="switch">
                            <path
                                id="sw2Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M172.402 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw2Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M172.031 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw2On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M172.03 397.612h-2.95v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw3" className="switch">
                            <path
                                id="sw3Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M178.777 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw3Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M178.406 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw3On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M178.406 397.612h-2.951v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw4" className="switch">
                            <path
                                id="sw4Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M185.152 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw4Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M184.781 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw4On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M184.78 397.612h-2.95v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw5" className="switch">
                            <path
                                id="sw5Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M191.527 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw5Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M191.156 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw5On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M191.156 397.612h-2.951v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw6" className="switch">
                            <path
                                id="sw6Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M197.902 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw6Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M197.53 389.117h-2.95v2.951h2.95z"
                                className="off"
                            ></path>
                            <path
                                id="sw6On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M197.53 397.612h-2.95v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw7" className="switch">
                            <path
                                id="sw7Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M204.277 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw7Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M203.906 389.117h-2.951v2.951h2.95z"
                                className="off"
                            ></path>
                            <path
                                id="sw7On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M203.906 397.612h-2.951v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw8" className="switch">
                            <path
                                id="sw8Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M210.652 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw8Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M210.28 389.117h-2.95v2.951h2.95z"
                                className="off"
                                display="inline"
                            ></path>
                            <path
                                id="sw8On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M210.28 397.612h-2.95v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                    </g>
                    <g
                        id="g9999"
                        fill="#fff"
                        fontFamily="monospace"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        transform="translate(.04)"
                    >
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text9608"
                            x="113.335"
                            y="-397.741"
                            fillOpacity="1"
                            strokeWidth="0.75"
                            fontSize="7"
                            transform="scale(1 -1)"
                        >
                            <tspan
                                id="tspan9606"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="113.335"
                                y="-397.741"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                INPUT
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text9612"
                            x="490.156"
                            y="188.163"
                            fillOpacity="1"
                            strokeWidth="0.75"
                            fontSize="10"
                            transform="matrix(0 1 1 0 0 0)"
                        >
                            <tspan
                                id="tspan9610"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                x="490.156"
                                y="188.163"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                            >
                                OUTPUT
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                                WebkitTextAlign: "center",
                                textAlign: "center",
                            }}
                            id="text6475"
                            x="100.935"
                            y="-462.327"
                            fillOpacity="1"
                            strokeDasharray="none"
                            strokeWidth="0.75"
                            fontSize="7"
                            textAnchor="middle"
                            transform="matrix(1 0 0 -1 1.09 .168)"
                        >
                            <tspan
                                id="tspan6473"
                                x="100.935"
                                y="-462.327"
                                fill="#fff"
                                strokeWidth="0.75"
                            >
                                LS1
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8778"
                            x="-438.288"
                            y="-130.852"
                            fillOpacity="1"
                            strokeWidth="0.769"
                            display="inline"
                            fontSize="7.177"
                            transform="matrix(0 -1.02531 -.97531 0 0 0)"
                        >
                            <tspan
                                id="tspan8776"
                                x="-438.288"
                                y="-130.852"
                                fill="#fff"
                                strokeWidth="0.769"
                                fontSize="7.177"
                            >
                                A0
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8782"
                            x="-437.715"
                            y="-137.625"
                            fillOpacity="1"
                            strokeWidth="0.77"
                            display="inline"
                            fontSize="7.187"
                            transform="matrix(0 -1.02666 -.97404 0 0 0)"
                        >
                            <tspan
                                id="tspan8780"
                                x="-437.715"
                                y="-137.625"
                                fill="#fff"
                                strokeWidth="0.77"
                                fontSize="7.187"
                            >
                                A1
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8786"
                            x="-434.359"
                            y="-145.234"
                            fillOpacity="1"
                            strokeWidth="0.776"
                            display="inline"
                            fontSize="7.242"
                            transform="matrix(0 -1.0346 -.96656 0 0 0)"
                        >
                            <tspan
                                id="tspan8784"
                                x="-434.359"
                                y="-145.234"
                                fill="#fff"
                                strokeWidth="0.776"
                                fontSize="7.242"
                            >
                                A2
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8790"
                            x="-436.28"
                            y="-151.161"
                            fillOpacity="1"
                            strokeWidth="0.773"
                            display="inline"
                            fontSize="7.21"
                            transform="matrix(0 -1.03004 -.97084 0 0 0)"
                        >
                            <tspan
                                id="tspan8788"
                                x="-436.28"
                                y="-151.161"
                                fill="#fff"
                                strokeWidth="0.773"
                                fontSize="7.21"
                            >
                                A3
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8794"
                            x="-419.893"
                            y="-164.16"
                            fillOpacity="1"
                            strokeWidth="0.804"
                            display="inline"
                            fontSize="7.505"
                            transform="matrix(0 -1.0721 -.93275 0 0 0)"
                        >
                            <tspan
                                id="tspan8792"
                                x="-419.893"
                                y="-164.16"
                                fill="#fff"
                                strokeWidth="0.804"
                                fontSize="7.505"
                            >
                                F0
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8798"
                            x="-419.295"
                            y="-171.322"
                            fillOpacity="1"
                            strokeWidth="0.805"
                            display="inline"
                            fontSize="7.515"
                            transform="matrix(0 -1.07363 -.93142 0 0 0)"
                        >
                            <tspan
                                id="tspan8796"
                                x="-419.295"
                                y="-171.322"
                                fill="#fff"
                                strokeWidth="0.805"
                                fontSize="7.515"
                            >
                                F1
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8802"
                            x="-415.791"
                            y="-179.599"
                            fillOpacity="1"
                            strokeWidth="0.812"
                            display="inline"
                            fontSize="7.579"
                            transform="matrix(0 -1.08272 -.9236 0 0 0)"
                        >
                            <tspan
                                id="tspan8800"
                                x="-415.791"
                                y="-179.599"
                                fill="#fff"
                                strokeWidth="0.812"
                                fontSize="7.579"
                            >
                                F2
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "monospace",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8806"
                            x="-417.797"
                            y="-185.602"
                            fillOpacity="1"
                            strokeWidth="0.808"
                            display="inline"
                            fontSize="7.542"
                            transform="matrix(0 -1.0775 -.92808 0 0 0)"
                        >
                            <tspan
                                id="tspan8804"
                                x="-417.797"
                                y="-185.602"
                                fill="#fff"
                                strokeWidth="0.808"
                                fontSize="7.542"
                            >
                                F3
                            </tspan>
                        </text>
                        <text
                            xmlSpace="preserve"
                            style={{
                                InkscapeFontSpecification: "'monospace, Normal'",
                                fontVariantLigatures: "normal",
                                fontVariantCaps: "normal",
                                fontVariantNumeric: "normal",
                                fontVariantEastAsian: "normal",
                            }}
                            id="text8633"
                            x="-180.974"
                            y="590.156"
                            strokeWidth="0.75"
                            display="inline"
                            fontSize="8"
                            transform="scale(-1 1)"
                            writingMode="vertical-lr"
                        >
                            <tspan id="tspan1530" x="-180.974" y="590.156">
                                - +
                            </tspan>
                            <tspan id="tspan1532" x="-170.974" y="590.156">
                                OUT
                            </tspan>
                            <tspan id="tspan1534" x="-160.974" y="590.156">
                                12V
                            </tspan>
                        </text>
                    </g>
                    <g id="g4507" display="inline">
                        <g id="relay8Group" transform="translate(-78.67 20.534)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8308"
                                x="297.269"
                                y="-341.013"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan8306"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-341.013"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D18
                                </tspan>
                            </text>
                            <path
                                id="relay8LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -350.338H306.82V-346.368H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay8"
                                className="header header-background"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="path8312"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8314"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8316"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8318"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8320"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8326"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8324"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    8
                                </tspan>
                            </text>
                        </g>
                        <g id="relay7Group" transform="translate(-78.67 53.963)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8284"
                                x="297.269"
                                y="-342.163"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan8282"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-342.163"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D17
                                </tspan>
                            </text>
                            <path
                                id="relay7LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -351.737H306.82V-347.767H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay7"
                                className="header"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="path8288"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8290"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8292"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8294"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8296"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8302"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8300"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    7
                                </tspan>
                            </text>
                        </g>
                        <g id="g8280" transform="translate(-78.67 87.713)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8260"
                                x="297.269"
                                y="-342.834"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan8258"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-342.834"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D16
                                </tspan>
                            </text>
                            <path
                                id="relay6LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -351.737H306.82V-347.767H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay6"
                                className="header"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="path8264"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8266"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8268"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8270"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8272"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8278"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8276"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    6
                                </tspan>
                            </text>
                        </g>
                        <g id="g8256" transform="translate(-78.67 121.463)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8236"
                                x="297.269"
                                y="-342.913"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan8234"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-342.913"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D15
                                </tspan>
                            </text>
                            <path
                                id="relay5LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -351.787H306.82V-347.81699999999995H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay5"
                                className="header"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="path8240"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8242"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8244"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8246"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8248"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8254"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8252"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    5
                                </tspan>
                            </text>
                        </g>
                        <g id="g8232" transform="translate(-78.67 155.213)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="relay4LEDLabel"
                                x="297.269"
                                y="-342.163"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan8210"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-342.163"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D14
                                </tspan>
                            </text>
                            <path
                                id="relay4LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -351.737H306.82V-347.767H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay4"
                                className="header"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="path8216"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8218"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8220"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8222"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8224"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8230"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8228"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    4
                                </tspan>
                            </text>
                        </g>
                        <g id="g8196" transform="translate(-78.67 188.963)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8176"
                                x="297.269"
                                y="-342.834"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan8174"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-342.834"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D13
                                </tspan>
                            </text>
                            <path
                                id="relay3LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -351.787H306.82V-347.81699999999995H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay3"
                                className="header"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="path8180"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8182"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8184"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8186"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8188"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8194"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8192"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    3
                                </tspan>
                            </text>
                        </g>
                        <g id="g832" transform="translate(-78.67 222.713)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text814"
                                x="297.269"
                                y="-342.834"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan812"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="297.269"
                                    y="-342.834"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D12
                                </tspan>
                            </text>
                            <path
                                id="relay2LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M301.421 -352.537H306.82V-348.56699999999995H301.421z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay2"
                                className="header"
                                transform="matrix(-1 0 0 1 660.34 0)"
                            >
                                <path
                                    id="relay2Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path824"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path826"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path828"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path830"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8170"
                                x="340.358"
                                y="319.038"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="matrix(0 1 1 0 0 0)"
                            >
                                <tspan
                                    id="tspan8168"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="340.358"
                                    y="319.038"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    2
                                </tspan>
                            </text>
                        </g>
                        <g id="g854" transform="translate(-148.079 251.405)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text836"
                                x="366.678"
                                y="-348.721"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan834"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="366.678"
                                    y="-348.721"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D11
                                </tspan>
                            </text>
                            <path
                                id="relay1LED"
                                fill="red"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M370.829 -358.345H376.228V-354.375H370.829z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <g
                                id="relay1"
                                className="header"
                                transform="matrix(-1 0 0 1 797.781 .9)"
                            >
                                <path
                                    id="relay1Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M407.954 332.327h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path846"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M404.525 343.077h2.554v-6.287h-2.554v1.85h-1.309v-3.622H390.09v9.661h13.126v-3.374h1.31z"
                                ></path>
                                <path
                                    id="path848"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M398.746 339.972a1.333 1.333 0 10-2.666 0 1.333 1.333 0 002.666 0"
                                ></path>
                                <path
                                    id="path850"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M404.525 354.004h2.554v-6.287h-2.554v1.85h-1.309v-3.62H390.09v9.66h13.126v-3.374h1.31z"
                                ></path>
                                <path
                                    id="path852"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M398.746 350.9a1.333 1.333 0 10-2.666 0 1.333 1.333 0 002.666 0"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{ InkscapeFontSpecification: "monospace" }}
                                id="text7372"
                                x="599.641"
                                y="239.893"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                transform="matrix(0 1 1 0 148.079 -251.405)"
                            >
                                <tspan
                                    id="tspan7370"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="599.641"
                                    y="239.893"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="10"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    1
                                </tspan>
                            </text>
                        </g>
                        <g id="g8609" transform="translate(-47.767 55.196)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8567"
                                x="230.443"
                                y="-324.664"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8565" x="230.443" y="-324.664">
                                    7
                                </tspan>
                            </text>
                            <g
                                id="input78"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="path8569"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8571"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path8573"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path8575"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path8577"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="path8579"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path8581"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                id="text8587"
                                x="245.675"
                                y="-337.481"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontSize="7"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                                xmlSpace="preserve"
                            >
                                <tspan
                                    id="tspan8585"
                                    x="245.675"
                                    y="-337.481"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontSize="7"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8591"
                                x="254.853"
                                y="-324.564"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8589" x="254.853" y="-324.564">
                                    8
                                </tspan>
                            </text>
                            <g
                                id="g8599"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path8593"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path8595"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path8597"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g8607"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path8601"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path8603"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path8605"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g8563" transform="translate(-96.517 55.196)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8521"
                                x="230.443"
                                y="-324.664"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8519" x="230.443" y="-324.664">
                                    5
                                </tspan>
                            </text>
                            <g
                                id="input56"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="path8523"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8525"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path8527"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path8529"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path8531"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="path8533"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path8535"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                id="text8541"
                                x="245.675"
                                y="-337.481"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontSize="7"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                                xmlSpace="preserve"
                            >
                                <tspan
                                    id="tspan8539"
                                    x="245.675"
                                    y="-337.481"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontSize="7"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8545"
                                x="254.853"
                                y="-324.564"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8543" x="254.853" y="-324.564">
                                    6
                                </tspan>
                            </text>
                            <g
                                id="g8553"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path8547"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path8549"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path8551"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g8561"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path8555"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path8557"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path8559"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g8517" transform="translate(-145.267 55.196)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8475"
                                x="230.443"
                                y="-324.664"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8473" x="230.443" y="-324.664">
                                    3
                                </tspan>
                            </text>
                            <g
                                id="input34"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="path8477"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8479"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path8481"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path8483"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path8485"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="path8487"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path8489"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                id="text8495"
                                x="245.675"
                                y="-337.481"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontSize="7"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                                xmlSpace="preserve"
                            >
                                <tspan
                                    id="tspan8493"
                                    x="245.675"
                                    y="-337.481"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontSize="7"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8499"
                                x="254.853"
                                y="-324.564"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8497" x="254.853" y="-324.564">
                                    4
                                </tspan>
                            </text>
                            <g
                                id="g8507"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path8501"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path8503"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path8505"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g8515"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path8509"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path8511"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path8513"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g950" transform="translate(-194.017 55.196)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text908"
                                x="230.443"
                                y="-324.664"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8469" x="230.443" y="-324.664">
                                    1
                                </tspan>
                            </text>
                            <g
                                id="input12"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="input12Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="input2"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path914"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path916"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path918"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="input1"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path922"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                id="text926"
                                x="245.675"
                                y="-337.481"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontSize="7"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                                xmlSpace="preserve"
                            >
                                <tspan
                                    id="tspan924"
                                    x="245.675"
                                    y="-337.481"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontSize="7"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text932"
                                x="254.853"
                                y="-324.564"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="10"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan8471" x="254.853" y="-324.564">
                                    2
                                </tspan>
                            </text>
                            <g
                                id="g940"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path934"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path936"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path938"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g948"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path942"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path944"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path946"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="g102"
                            clipPath="url(#clipPath106)"
                            display="inline"
                            transform="translate(-97.81 81.931)"
                        >
                            <g
                                id="g4693"
                                fill="red"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4857"
                                    x="122.367"
                                    y="-468.911"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4855"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.367"
                                        y="-468.911"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D+
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4699"
                                    x="122.224"
                                    y="-457.717"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4697"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.224"
                                        y="-457.717"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D-
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4573"
                                    x="122.288"
                                    y="-479.787"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4571"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.288"
                                        y="-479.787"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        12V+
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4683"
                                    x="122.512"
                                    y="-490.743"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4681"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.512"
                                        y="-490.743"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        GND-
                                    </tspan>
                                </text>
                            </g>
                            <g id="rs485Header" className="header">
                                <path
                                    id="rs485Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M120.732 452.984H101.78v48.085h18.952z"
                                    className="header-background"
                                    display="inline"
                                ></path>
                                <path
                                    id="path130"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.848h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    display="inline"
                                    transform="translate(117.31 463.845)"
                                ></path>
                                <path
                                    id="path134"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 460.74)"
                                ></path>
                                <path
                                    id="path122"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    display="inline"
                                    transform="translate(117.31 474.772)"
                                ></path>
                                <path
                                    id="path126"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 471.666)"
                                ></path>
                                <path
                                    id="path114"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    display="inline"
                                    transform="translate(117.31 485.7)"
                                ></path>
                                <path
                                    id="path118"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 482.594)"
                                ></path>
                                <path
                                    id="path98"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.373H0z"
                                    display="inline"
                                    transform="translate(117.31 496.627)"
                                ></path>
                                <path
                                    id="path110"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 493.522)"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="powerOutput"
                            className="header"
                            transform="matrix(-1 0 0 1 607.513 195.064)"
                        >
                            <path
                                id="path8635"
                                fill="#63b47f"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M422.031 389.567h-18.952v26.117h18.952z"
                                className="-background header-background"
                                display="inline"
                            ></path>
                            <path
                                id="path8637"
                                fill="#2c7039"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                display="inline"
                                transform="translate(418.602 400.318)"
                            ></path>
                            <path
                                id="path8639"
                                fill="#be9a3a"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                display="inline"
                                transform="translate(412.823 397.213)"
                            ></path>
                            <path
                                id="path8641"
                                fill="#2c7039"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                display="inline"
                                transform="translate(418.602 411.245)"
                            ></path>
                            <path
                                id="path8643"
                                fill="#be9a3a"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                display="inline"
                                transform="translate(412.823 408.14)"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}